import React, { useState } from "react";
import { Flex, Textarea, Button } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

export interface ChatInputProps {
  placeholder: string;
  onSubmit: (prompt: string) => void;
  disabled?: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({ placeholder, onSubmit, disabled }) => {
  const [prompt, setPrompt] = useState("");
  const handleSubmit = () => {
    onSubmit(prompt.trim());
    setPrompt("");
  };
  return (
    <Flex alignItems="center" gap={Sizes.SM} className={styles.inputContainer}>
      <Textarea
        placeholder={placeholder}
        value={prompt}
        onSetValue={(value) => setPrompt(value)}
        isFullWidth
        size="x-small"
        className={styles.inputTextArea}
        disabled={disabled}
      />
      <Button
        data-testid="prompt-submit-button"
        icon="arrow-right"
        onClick={handleSubmit}
        disabled={disabled || !prompt.trim()}
      />
    </Flex>
  );
};
